"use strict";

var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Weather = exports.decodeWeather = void 0;
/**
 * decodeWeather decodes an API originating weather object into a Weather. Note that this function is recursive with regard to its history array
 * @param w an API originated weather object
 * @returns a Weather object containing the same information
 */

function decodeWeather(w) {
  var e_1, _a;

  var hist = [];

  if (w.history) {
    try {
      for (var _b = __values(w.history), _c = _b.next(); !_c.done; _c = _b.next()) {
        var h = _c.value;
        hist.push(decodeWeather(h));
      }
    } catch (e_1_1) {
      e_1 = {
        error: e_1_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
  }

  var windDirection = w.wind_direction;

  if (windDirection == null) {
    windDirection = w.windDirection;
  }

  var windSpeed = w.wind_speed;

  if (windSpeed == null) {
    windSpeed = w.windSpeed;
  }

  return new Weather(new Date(w.time), w.temperature, w.weather, windDirection, windSpeed, w.pressure, w.precipitation, hist);
}

exports.decodeWeather = decodeWeather;
/** the Weather class holds both the current weather and an array of Weathers for historic times (last 24 hours) */

var Weather =
/** @class */
function () {
  function Weather(time, temp, weather, windDirection, windSpeed, pressure, precipitation, history) {
    this.time = time;
    this.temperature = temp;
    this.weather = weather;
    this.windDirection = windDirection;
    this.windSpeed = windSpeed;
    this.pressure = pressure;
    this.precipitation = precipitation;

    if (history) {
      this.history = history;
    } else {
      this.history = [];
    }
  }

  return Weather;
}();

exports.Weather = Weather;